import { useEffect } from 'react';

export default function usePersistImageSize() {
  useEffect(() => {
    function handler(e) {
      const img = e.target;
      if (img.tagName !== 'IMG') return;
      if (img.hasAttribute('width')) return; // nothing to do
      img.setAttribute('width', img.naturalWidth);
      img.setAttribute('height', img.naturalHeight);
    }
    document.addEventListener('load', handler, true);
    return () => document.removeEventListener('load', handler, true);
  }, []);
}
